import { useMemo, memo } from "react";
import Chart from "react-apexcharts";
import "./chart.css";

function ChartBarIncidence({
  data,
  categoryKey = "AnoNotificacao",
  valueKey = "NumeroCasos",
  percentageKey = "Incidencia",
  // O agrupamento no backend é por ANO_DIAG, derivado de DT_DIAG — data do
  // diagnóstico, não da digitação no SINAN (a ficha é preenchida à mão e a
  // notificação costuma entrar no sistema bem depois).
  titleX = "Ano/Mês de Diagnóstico",
  titleY = "Número de Casos",
  titleY2 = "Incidência",
  seriesNameBar = "Número de Casos",
  seriesNameLine = "Incidência",
}) {
  const sortedData = useMemo(
    () => data ? [...data].sort((a, b) => a[categoryKey] - b[categoryKey]) : [],
    [data, categoryKey]
  );

  const categories = useMemo(
    () => sortedData.map((item) => item[categoryKey]),
    [sortedData, categoryKey]
  );

  const series = useMemo(
    () => [
      { name: seriesNameBar, type: "bar", data: sortedData.map((item) => item[valueKey]) },
      { name: seriesNameLine, type: "line", data: sortedData.map((item) => item[percentageKey]) },
    ],
    [sortedData, seriesNameBar, seriesNameLine, valueKey, percentageKey]
  );

  const options = useMemo(() => {
    const valMin = sortedData.length ? Math.min(...sortedData.map((item) => item[valueKey])) : 0;
    const valMax = sortedData.length ? Math.max(...sortedData.map((item) => item[valueKey])) : 1;
    const pctMin = sortedData.length ? Math.min(...sortedData.map((item) => item[percentageKey])) : 0;
    const pctMax = sortedData.length ? Math.max(...sortedData.map((item) => item[percentageKey])) : 1;
    return {
      chart: { type: "line" },
      stroke: { width: [0, 3] },
      dataLabels: {
        enabled: true,
        formatter: (val, { seriesIndex }) => seriesIndex === 0 ? val : `${val.toFixed(1)}`,
      },
      plotOptions: { bar: { dataLabels: { position: "center" } } },
      xaxis: {
        categories,
        title: { text: titleX, style: { color: "var(--text-50)" } },
        labels: { style: { colors: "var(--text-50)" } },
      },
      yaxis: [
        {
          title: { text: titleY, style: { color: "var(--text-50)" } },
          min: valMin * 0,
          max: valMax * 1.1,
          labels: {
            style: { colors: "var(--text-50)" },
            formatter: (val) => `${val.toFixed(0)}`,
          },
        },
        {
          opposite: true,
          title: { text: titleY2, style: { color: "var(--text-50)" } },
          min: pctMin * 0,
          max: pctMax * 1,
          labels: {
            style: { colors: "var(--text-50)" },
            formatter: (val) => `${val.toFixed(1)}`,
          },
        },
      ],
      tooltip: {
        y: { formatter: (val, { seriesIndex }) => seriesIndex === 0 ? val : `${val.toFixed(2)}` },
      },
      legend: { labels: { colors: "var(--text-50)" } },
    };
  }, [sortedData, categories, titleX, titleY, titleY2, valueKey, percentageKey]);

  if (!data) return null;

  return <Chart options={options} series={series} type="line" height="100%" width="100%" />;
}

export default memo(ChartBarIncidence);
